import React, { useState } from "react";
import {
  useTable,
  usePagination,
  useSortBy,
  useExpanded,
  useGlobalFilter,
  useRowSelect
} from "react-table";
import {TRASNPORTER_DATA_COLUMNS} from "../../columns/transporterColumns"
import { defaultTransporterColumn } from "../cells/editable/transporterEditableCell";
import TransporterActionCenter from "../action-center/TransporterActionCenter";
import { filter } from "lodash";
import MainTablePaginationAdv from "./MainTablePaginationAdv";
import { TableCheckbox } from "./TableCheckbox";


function TransporterDataTable({
  tableData,
  date,
  setDate,
  setShowDailyPlanUploader,
  dataExportHandler,
  subModule,
  // newSelectedFlatRows,
  // setNewSelectedFlatRows,
  maerskTemplateFileExportHandler,
  hapagTemplateFileExportHandler,
  transporterUploadTemplateFileExportHandler,
  filteredUserAccessData,
  noDataState,
  setNoDataState,
  setCarrierList
  // setCopyData
}) {
  const [columns] = useState(TRASNPORTER_DATA_COLUMNS);
  // const [showDeleteModal, setShowDeleteModal] = useState(null);
  const [showDisableCellForJD, setShowDisableCellForJD] = useState(false)

  var allowToEdit = filter(filteredUserAccessData,{Edit:1}).length > 0

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    state,
    setPageSize,
    canPreviousPage,
    setGlobalFilter,
    prepareRow,
    selectedFlatRows,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data: tableData,
      defaultColumn:defaultTransporterColumn,
      autoResetPage: false,
      initialState: { pageSize: 50 },
      autoResetExpanded: false,
      autoResetGlobalFilter: false,
      showDisableCellForJD,
      setShowDisableCellForJD,
      // newSelectedFlatRows,
      allowToEdit
      // setCopyData
    },
    useGlobalFilter,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: "selection",
          Header: ({ getToggleAllPageRowsSelectedProps }) => (
            <div>
              <TableCheckbox {...getToggleAllPageRowsSelectedProps()} />
            </div>
          ),
          Cell: ({ row }) => (
            <div>
              <TableCheckbox {...row.getToggleRowSelectedProps()} />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  // useEffect(() => {
  //   setNewSelectedFlatRows(selectedFlatRows)
  // },[selectedFlatRows, setNewSelectedFlatRows])

  
  const { pageIndex, pageSize, globalFilter } = state;

  return (
    <>
      <div className="table_actionsforTransporter">
        {/* <Form.Group>
          <Form.Control
            value={globalFilter || ""}
            onChange={(e) => setGlobalFilter(e.target.value)}
            className="hiden-inp"
            placeholder="search here.."
          />
        </Form.Group> */}
        <TransporterActionCenter
          date={date}
          setDate={setDate}
          setShowDailyPlanUploader={setShowDailyPlanUploader}
          dataExportHandler={dataExportHandler}
          selectedFlatRows={selectedFlatRows}
          subModule={subModule}
          allColumns={allColumns}
          getToggleHideAllColumnsProps={getToggleHideAllColumnsProps}
          type={"Daily"}
          maerskTemplateFileExportHandler={maerskTemplateFileExportHandler}
          hapagTemplateFileExportHandler={hapagTemplateFileExportHandler}
          transporterUploadTemplateFileExportHandler={
            transporterUploadTemplateFileExportHandler
          }
          filteredUserAccessData={filteredUserAccessData}
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
          setNoDataState={setNoDataState}
          setCarrierList={setCarrierList}
        />
      </div>
      {!noDataState && (
        <>
          <div className="table_container">
            <table {...getTableProps()} className="table mtbs">
              <thead>
                {headerGroups.map((headerGroup) => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map((column) => (
                      <th
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className="transporter_table_class"
                      >
                        {column.render("Header")}
                        {column.id !== "selection" && (
                          <i
                            className={
                              column.isSorted
                                ? column.isSortedDesc
                                  ? "fi fi-rr-angle-small-down head-icon"
                                  : "fi fi-rr-angle-small-up head-icon"
                                : "fi fi-rr-circle-small head-icon w"
                            }
                          ></i>
                        )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {page.map((row) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => {
                        return (
                          <td
                            {...cell.getCellProps()}
                            className={
                              cell.row.subRows.length !== 0
                                ? "main-row"
                                : "sub-row"
                            }
                          >
                            <div className="cell-wrap">
                              {cell.render("Cell")}
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* <MainTablePagination
        nextPage={nextPage}
        previousPage={previousPage}
        canNextPage={canNextPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canPreviousPage={canPreviousPage}
        setPageSize={setPageSize}
      /> */}
          <MainTablePaginationAdv
            nextPage={nextPage}
            previousPage={previousPage}
            canNextPage={canNextPage}
            pageIndex={pageIndex}
            pageOptions={pageOptions}
            pageSize={pageSize}
            canPreviousPage={canPreviousPage}
            setPageSize={setPageSize}
            gotoPage={gotoPage}
            pageCount={pageCount}
          />
        </>
      )}
    </>
  );
}

export default TransporterDataTable;
